import { Routes } from '@angular/router';

import { authGuard } from './public/auth/guards/auth.guard';

export const routes: Routes = [
  // Public: Authentication
  {
    path: 'auth',
    loadChildren: () => import('./public/auth/auth.routes').then((m) => m.AUTH_ROUTES),
  },
  // Public: Legal
  {
    path: 'legal',
    children: [
      {
        path: 'terms',
        loadComponent: () => import('./public/legal/terms/terms.page').then((m) => m.TermsPage),
      },
      {
        path: 'privacy',
        loadComponent: () =>
          import('./public/legal/privacy/privacy.page').then((m) => m.PrivacyPage),
      },
    ],
  },
  // Authenticated: App
  {
    path: '',
    loadChildren: () => import('./layout/layout.routes').then((m) => m.LAYOUT_ROUTES),
    canActivate: [authGuard],
  },
];
